import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Home from '../pages/Home';
import Room from '../pages/Room';

import SocketProvider from '../context/SocketContext';
import RoomProvider from '../context/RoomContext';
import PlayerProvider from '../context/PlayerContext';

const Router = () => (
  <BrowserRouter>
    <Routes>
      <Route
        path="/"
        element={
          <SocketProvider>
            <Home />
          </SocketProvider>
        }
      />

      <Route
        path="/room/:roomId"
        element={
          <SocketProvider>
            <RoomProvider>
              <PlayerProvider>
                <div className="w-full h-screen bg-slate-200 flex items-center justify-center flex-col">
                  <Room />
                </div>
              </PlayerProvider>
            </RoomProvider>
          </SocketProvider>
        }
      />
    </Routes>
  </BrowserRouter>
);

export default Router;
